export interface EventRemindLabelProps {
  name: string
}
